// api/logApi.js - Sistem logları API işlemleri
import axios from 'axios';

// Token ile yetkilendirme
const setAuthToken = (token) => {
  if (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers.common['Authorization'];
  }
};

// Tüm logları getir
export const getLogs = async () => {
  const token = localStorage.getItem('token');
  setAuthToken(token);
  
  try {
    const response = await axios.get('/api/logs');
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Loglar alınırken bir hata oluştu');
  }
};

// Belirli bir eyleme göre logları filtrele
export const getLogsByAction = async (action) => {
  const token = localStorage.getItem('token');
  setAuthToken(token);
  
  try {
    const response = await axios.get(`/api/logs/action/${action}`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Log filtresi uygulanırken bir hata oluştu');
  }
};

// Silme işlemlerini içeren logları getir
export const getDeletionLogs = async () => {
  const token = localStorage.getItem('token');
  setAuthToken(token);
  
  try {
    const response = await axios.get('/api/logs/deletions');
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Silme logları alınırken bir hata oluştu');
  }
};

// Tüm logları temizle
export const clearAllLogs = async () => {
  const token = localStorage.getItem('token');
  setAuthToken(token);
  
  try {
    const response = await axios.delete('/api/logs/clear');
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Loglar temizlenirken bir hata oluştu');
  }
};

// Belirli bir iadeye ait güncelleme loglarını getir
export const getRefundUpdateLogs = async (refundId) => {
  const token = localStorage.getItem('token');
  setAuthToken(token);
  
  try {
    const response = await axios.get(`/api/logs/refund/${refundId}`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'İade logları alınırken bir hata oluştu');
  }
}; 